import { ItemType } from "antd/es/menu/interface";
import dayjs from "dayjs";
import pluralize from "pluralize";
import { PostCommentData } from "store/posts/postConstants";
import { UserInfo } from "store/user/userConstants";

export const getTimeAgo = (createdAt?: string) => {
  if (!createdAt) {
    return "Unknown";
  }

  const timestamp = dayjs.utc(createdAt);
  const now = dayjs.utc();

  const minuteDiff = now.diff(timestamp, "m");

  if (minuteDiff < 1) {
    return "Just now";
  }

  const hourDiff = now.diff(timestamp, "h");
  let diffString = "";

  if (hourDiff < 1) {
    // This means 1 <= minuteDiff < 60
    diffString = pluralize("minute", minuteDiff, true);
  } else if (hourDiff < 24) {
    // This means 1 <= hourDiff < 24
    diffString = pluralize("hour", hourDiff, true);
  } else {
    // This means dayDiff >= 1
    const dayDiff = now.diff(timestamp, "d");
    diffString = pluralize("day", dayDiff, true);
  }

  return `${diffString} ago`;
};

export const getCommentMenuItems = ({
  readonly,
  currentComment,
  currentUser,
  editingComment,
  onEdit,
  onDelete,
}: {
  readonly?: boolean;
  currentComment?: PostCommentData;
  currentUser: UserInfo;
  editingComment: string | null | "new";
  onEdit: () => void;
  onDelete: () => void;
}): ItemType[] | null => {
  if (
    !readonly &&
    currentComment &&
    currentComment.user_id === currentUser.id
  ) {
    return [
      {
        key: "edit",
        label: "Edit",
        disabled: Boolean(
          editingComment && editingComment !== currentComment.id
        ),
        onClick: onEdit,
      },
      { key: "delete", label: "Delete", onClick: onDelete },
    ];
  }
  return null;
};
